module.exports = __webpack_public_path__ + "img/chiefDresser.ba4a9efc.png";